// Single source for VENKA public contact details (website, contact page, footer).
// Defaults below; the numbers set in ERP > Settings > Company override them at runtime (usePhones).
import { useEffect, useState } from "react";

export const PHONES = {
  angola: { display: "+244 226 431 700", tel: "+244226431700",
    label: { en: "Angola", pt: "Angola", fr: "Angola" } },
  intl: { display: "+1 229 595 5528", tel: "+12295955528",
    label: { en: "Estonia & rest of the world", pt: "Estónia e resto do mundo", fr: "Estonie et reste du monde" } },
};
export const EMAIL = "sales@venkawe.com";
export const OFFICES = {
  luanda: "Bloco 10, Prédio 12-A, apt. 302, Cidade do Sequele, Angola",
  tallinn: "Tartu mnt 67/1-13b, Kesklinna linnaosa, 10115 Tallinn, Harju maakond, Estonia",
};

const tel = (s) => "+" + String(s || "").replace(/[^\d]/g, "");
let cache = null;
let pending = null;

function fromSettings(s) {
  const c = (s && s.company) || {};
  const out = { angola: { ...PHONES.angola }, intl: { ...PHONES.intl } };
  if (c.phone) out.angola = { ...out.angola, display: c.phone, tel: tel(c.phone) };
  if (c.phone_intl) out.intl = { ...out.intl, display: c.phone_intl, tel: tel(c.phone_intl) };
  return out;
}

/** Phone numbers from Settings (falls back to the defaults while loading or offline). */
export function usePhones() {
  const [phones, setPhones] = useState(cache || PHONES);
  useEffect(() => {
    if (cache) return undefined;
    let alive = true;
    pending = pending || fetch(`${process.env.REACT_APP_BACKEND_URL || ""}/api/settings/public`).then((r) => (r.ok ? r.json() : null))
      .then((s) => { cache = fromSettings(s); return cache; }).catch(() => PHONES);
    pending.then((p) => { if (alive) setPhones(p); });
    return () => { alive = false; };
  }, []);
  return phones;
}

/** Which line a visitor should call: Angola for visitors in Angola, the international line for everyone else. */
export function regionKey() {
  try {
    if ((Intl.DateTimeFormat().resolvedOptions().timeZone || "") === "Africa/Luanda") return "angola";
  } catch (e) { /* ignore */ }
  return "intl";
}
export function localPhone() {
  return (cache || PHONES)[regionKey()];
}
